import { render, staticRenderFns } from "./DecisionCardBody.vue?vue&type=template&id=778262c6&"
import script from "./DecisionCardBody.vue?vue&type=script&lang=ts&"
export * from "./DecisionCardBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports